module.exports = __webpack_public_path__ + "e87f131fcb454d2076178c06da65fc05.svg";